import { render, staticRenderFns } from "./p24.vue?vue&type=template&id=928142a2&scoped=true&"
import script from "./p24.vue?vue&type=script&lang=js&"
export * from "./p24.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "928142a2",
  null
  
)

export default component.exports